import {
    Component,
    ViewEncapsulation
} from '@angular/core';

@Component({
    selector: 'app-power-base',
    templateUrl: './base.component.pug',
    styleUrls: ['./base.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class BaseComponent {
    constructor(
    ) {
    }
}
